// extracted by mini-css-extract-plugin
export default {"banner":"MigrationBanner_banner__eK1eb","link":"MigrationBanner_link__7b+4d"};